'use client';
import Icon from '@/Icon';
import { freezeAtom } from '@/legacy/components/apps/Freeze';
import { store } from '@/legacy/components/apps/Jotai';
import modalStyles from '@/legacy/components/apps/modal.module.scss';
import { clc } from '@/legacy/components/base/utils';
import ChannelTalk from '@/legacy/components/widget/ChannelTalk';
import styles from '@/legacy/components/widget/chat.module.scss';
import { atom, useAtomValue } from 'jotai';

type Props = {
	type: 'google' | 'apple' | 'chat';
};

export const ReactAlertAtom = atom(0);
export const ChatVisibleAtom = atom(true);

export const ChatVisibleAtomSet = (data: boolean) => store.set(ChatVisibleAtom, data);

const Dot = ({ className }: { className?: string }) => {
	return <div className={clc(styles.dot, className)} />;
};

export const Chat = ({ type }: Props) => {
	const badge = useAtomValue(ReactAlertAtom);
	const isFreeze = useAtomValue(freezeAtom);

	if (type === 'chat')
		return (
			<button
				className={clc(styles.button, isFreeze && modalStyles.scrollPadding)}
				onClick={() => {
					if (window.ChannelIO) window.ChannelIO('openChat');
				}}
			>
				<Icon className={styles.icon} color1="#FDFDFE" path="Action_FloatingChat_64_Default" />
				{badge > 0 && <Dot className={styles.char} />}
			</button>
		);

	return null;
};

const FloatArea = () => {
	const isChat = useAtomValue(ChatVisibleAtom);

	if (!isChat) return null;

	return (
		<div className={clc(styles.floatArea)}>
			<ChannelTalk />
			<Chat type="chat" />
		</div>
	);
};

export default FloatArea;
